import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateAmET: NDateLocale = {
  name: 'am-ET',
  locale: enUS
}

export default dateAmET
